/** @jsx jsx */
import { Component } from 'react'
import { connect } from 'react-redux'
import { head, get, map, size, filter } from 'lodash'
import { default_theme as theme } from '../../emotion/theme'
import { jsx, css } from '@emotion/core'
import BlueButton from '../layout/BlueButton'
import { Separator } from '../layout/Separator'
import SummaryAssesmentSummaryMessage from './SummaryAssesmentSummaryMessage'

class SurveySummary extends Component {

    componentDidMount() {
        window.scroll(0, 0)        
    }
    
    onContinue = () => {
        const { onContinue } = this.props
        onContinue()
    }

    onRedo = () => {
        const { onRedo } = this.props
        onRedo()
    }

    onRedoFromMedia = () => {
        const { onRedoFromMedia } = this.props
        onRedoFromMedia()
    }
    
    render() {
        const { customer_section } = this.props
        const passed = customer_section.passed
        return (
            <div>
              { this.renderSurveySummary() }
            </div>
        )
    }

    renderSurveySummary() {
        const { customer_section, course_section, course } = this.props
        const score_percentage = get(customer_section, "score_percentage", null)
        const has_next_section = !course_section.is_last_section

        const msg = has_next_section ? "You can now proceed to the next module" :
              `This was the last module in this ${course && course.course_type}, proceed to view your overall result.`

        const title = "Thank you for your submission!"
                    
        return (
            <div>
              <SummaryAssesmentSummaryMessage title={title} msg={msg}>
                
                <div css={section_summary_button_container}>
                  
                  <BlueButton css={summary_button_style} size="lg" onClick={this.onContinue}>
                    { has_next_section && 
                      <span>CONTINUE LEARNING</span>
                    }
                    { ! has_next_section && 
                      <span>COMPLETE COURSE</span>
                    }
                  </BlueButton>
                </div>

                <Separator variant="h50" />
                
              </SummaryAssesmentSummaryMessage>

              <Separator variant="h80" />
              
            </div>
        )
    }
    
}

function mapStateToProps(state, props) {
    return {}
}
    

export default connect(mapStateToProps)(SurveySummary)

const section_summary__passed = css`
background: #48B02C;
`

const section_summary__failed = css`
background: #ED2629;
`


const section_summary_button_container = css`
display: flex;
justify-content: center;
`

const summary_button_style = css`
font-size: 14px;
`
